import {getCurrentYear} from '../../utils/commons'
import BestOnlinePicksLogo from './logo'
import {bestOnlinePicksStylesCA, bestOnlinePicksStylesUK} from './styles'

const baseConfig = {
  domainName: 'bestonlinepicks' as const,
  domainType: 'brg' as const,
  siteName: 'Best Online Picks',
  favicon: '/favicons/bestonlinepicks.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-T1EPGM8WG5',
    camelCaseUrl: 'BestOnlinePicks.co.uk',
    logo: <BestOnlinePicksLogo className="size-10 shrink-0 tablet:size-8" locale="uk" />,
    title: (category: string, count: string) =>
      `Top ${count} Best ${category} ${getCurrentYear()} in the UK | BestOnlinePicks.co.uk – Reviews & Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `BestOnlinePicks.co.uk – Shop with confidence from a curated selection of UKs top picked producs. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: bestOnlinePicksStylesUK,
  },
  ca: {
    measurementId: 'G-C6CZ28HWEH',
    camelCaseUrl: 'BestOnlinePicks.ca',
    logo: <BestOnlinePicksLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
    title: (category: string, count: string) =>
      `Top ${count} Best  ${category} ${getCurrentYear} in CA | BestOnlinePicks.ca – Reviews & Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `BestOnlinePicks.ca – Shop with confidence from a curated selection of CAs top picked producs. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: bestOnlinePicksStylesCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
